import { useForm, isNotEmpty } from '@mantine/form';

import { useShowResponseStatus, useAppSelector, selectCurrencies } from '@/shared';
import { useCreateWithdrawalMethodMutation } from '../store/withdrawal-methods-api';

import type { TWithdrawalMethodCreateParams } from '../store/types';

type FormData = TWithdrawalMethodCreateParams;

const initialValues: FormData = {
  name: '',
  currency: '',
  minAmount: 0,
  maxAmount: 0,
  withdrawalPercent: 0,
  withdrawalFee: 0,
  active: false,
};

export const useCreateWithdrawalMethod = (onClose: () => void) => {
  const avalableCurrencies = useAppSelector(selectCurrencies);

  const [createWithdrawalMethod, {
    isLoading,
    isSuccess,
    isError,
  }] = useCreateWithdrawalMethodMutation();

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues,
    validate: {
      name: isNotEmpty('Введите имя'),
      currency: isNotEmpty('Выберите валюту'),
      minAmount: (value) => !value ? 'Введите минимальную сумму' : null,
      maxAmount: (value) => !value ? 'Введите максимальную сумму' : null,
      withdrawalPercent: (value) => !value ? 'Введите процент вывода' : null,
      withdrawalFee: (value) => !value ? 'Введите фикс' : null,
    },
  });

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Метод вывода успешно добавлен',
    isError,
    errorMassage: 'При добавлении метода вывода произошла ошибка',
  });

  const handleSubmit = async (values: FormData) => {
    // console.log('create values:', values);
    await createWithdrawalMethod(values);
    onClose();
  };

  return {
    avalableCurrencies,
    form,
    isLoading,
    handleSubmit,
  };
};
